export const links = {
  skool: "https://www.skool.com/radardigital/about",
  mercadopago:
    "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=facbcf842a654b5bb86154e1e99af913",
  whatsapp: "https://chat.whatsapp.com/FaXwTNHKJaB44hVJYF7QmI",
  instagram: "https://www.instagram.com/marketingconmarcos/",
  tiktok: "https://www.tiktok.com/@mkt_con_marcos",
};

export const stats = [
  { value: "4", label: "años vendiendo productos digitales" },
  { value: "2.500+", label: "alumnos en comunidades activas" },
  { value: "$1.094", label: "USD generados en un mes de ejemplo" },
  { value: "LATAM", label: "ventas en Argentina, México, Chile y Colombia" },
];

export const modules = [
  { title: "Bienvenida y primeros pasos", description: "Cómo funciona el sistema y por dónde empezar" },
  { title: "Investigación de producto", description: "Encontrá un ebook que ya tiene demanda comprobada" },
  { title: "Modelar tu ebook", description: "Cómo crear tu propio producto digital paso a paso" },
  { title: "Páginas y entregables con IA", description: "Usá Claude para crear tu ebook y página de ventas" },
  { title: "Hotmart", description: "Configurá tu producto para vender en dólares al mundo" },
  { title: "Shopify", description: "Vendé en pesos en Argentina con Mercado Pago" },
  { title: "Creación de creativos", description: "Diseñá los anuncios que van a vender tu ebook" },
  { title: "Facebook Ads", description: "Escalá tus ventas con publicidad paga sin desperdiciar plata" },
];

export const testimonials = [
  {
    name: "Vilma Acosta",
    meta: "64 años · Capital Federal",
    initial: "V",
    color: "#6c3483",
    result: "Primera venta en menos de 24 horas",
    quote:
      "Anoche a las 12 largué la campaña y hoy vendí uno. ¡Estoy chocha! Hice todo como acordamos y al otro día, viajando en auto, vendí otro ebook.",
  },
  {
    name: "Carlos López",
    meta: "Argentina · Ebook de marketing",
    initial: "C",
    color: "#1a5276",
    result: "$1.200 USD en el primer mes",
    quote:
      "En 3 semanas ya tenía $1.200 USD en mi cuenta de Hotmart. Nunca había vendido nada online antes de entrar a Radar Digital.",
  },
  {
    name: "Sofía Rodríguez",
    meta: "México · Ebook de finanzas",
    initial: "S",
    color: "#1e8449",
    result: "38 ventas en el primer mes",
    quote:
      "Mi tienda en Shopify vendió 38 ebooks en el primer mes. Sin invertir en publicidad. El método de Marcos funciona de verdad.",
  },
  {
    name: "Diego Mercado",
    meta: "Colombia · Ebook de negocios",
    initial: "D",
    color: "#7d6608",
    result: "$2.100 USD/mes en piloto automático",
    quote:
      "Con Shopify armé mi tienda en un día. Hoy genero $2.100 USD por mes en piloto automático. No lo podía creer.",
  },
];

export const faqs = [
  {
    q: "¿Necesito experiencia previa para entrar a Radar Digital?",
    a: "No. El programa está diseñado desde cero. Si nunca vendiste nada por internet, este es el lugar para empezar. Arrancamos desde la investigación del producto hasta la primera venta.",
  },
  {
    q: "¿En cuánto tiempo puedo tener mi primer ebook listo?",
    a: "Con el método del programa podés tener tu primer ebook creado en una semana. No necesitás saber diseño ni redacción avanzada, usamos inteligencia artificial para todo eso.",
  },
  {
    q: "¿Funciona si vivo fuera de Argentina?",
    a: "Sí, el sistema funciona para toda Latinoamérica. Hotmart te permite cobrar en dólares desde cualquier país y Shopify también acepta múltiples monedas.",
  },
  {
    q: "¿Qué pasa si tengo dudas durante el proceso?",
    a: "Cada semana tenemos una asesoría en vivo conmigo donde revisamos tu negocio, respondemos preguntas y te digo exactamente qué hacer. No quedás solo en ningún momento.",
  },
  {
    q: "¿Puedo cancelar la suscripción cuando quiero?",
    a: "Sí, la suscripción es mensual y podés cancelarla en cualquier momento desde tu panel de Skool. Sin contratos ni penalidades.",
  },
  {
    q: "¿Qué tipo de ebooks puedo vender?",
    a: "Cualquier tema en el que tengas conocimiento o experiencia. Recetas, finanzas, crianza, oficios, salud, emprendimiento, idiomas, hobbies. Si hay personas que quieren aprender algo, hay un ebook para vender.",
  },
];
